import { useMemo } from 'react';
import { UMBRALES_IVT } from '../utils/umbralesVITA';

export function useCognitiveAlerts(processedActors = []) {
  const alerts = useMemo(() => {
    const result = [];

    // ── ALERTA 1: IVT sobre umbral ─────────────────────────
    processedActors.forEach((actor) => {
      const ivt = actor._vita?.scoring?.IVT;
      const estado = actor._vita?.state?.state;
      const narrativa = actor._vita?.reasoning?.narrativaDominante || '';

      if (ivt >= UMBRALES_IVT.ESCALAMIENTO) {
        result.push({
          id: `cog_ivt_critical_${actor.id}`,
          tipo: 'ESCALAMIENTO',
          nivel: 'Crítico',
          titulo: `${actor.nombre} — Escalamiento territorial detectado`,
          descripcion: `IVT ${ivt}% supera umbral crítico. Estado: ${estado}. ${narrativa ? `Narrativa: "${narrativa}"` : ''}`,
          actor: actor.nombre,
          ivt,
          cognitiva: true
        });
      } else if (ivt >= UMBRALES_IVT.ACTIVACION) {
        result.push({
          id: `cog_ivt_activation_${actor.id}`,
          tipo: 'ACTIVACIÓN',
          nivel: 'Alto',
          titulo: `${actor.nombre} — Activación territorial`,
          descripcion: `IVT ${ivt}% indica activación territorial. Estado: ${estado}. ${narrativa ? `Narrativa: "${narrativa}"` : ''}`,
          actor: actor.nombre,
          ivt,
          cognitiva: true
        });
      }
    });

    // ── ALERTA 2: Convergencia narrativa ───────────────────
    const narrativaMap = {};

    processedActors.forEach((actor) => {
      const narrativas = actor.narrativas || [];
      if (actor.narrativaDominante && !narrativas.includes(actor.narrativaDominante)) {
        narrativas.push(actor.narrativaDominante);
      }

      narrativas.forEach((narrativa) => {
        if (!narrativa) return;
        const txt = typeof narrativa === 'string' ? narrativa.trim() : (narrativa?.texto || '').trim();
        if (!txt) return;
        const key = txt.toLowerCase();
        if (!narrativaMap[key]) narrativaMap[key] = { texto: txt, actores: [] };
        if (!narrativaMap[key].actores.includes(actor.nombre)) {
          narrativaMap[key].actores.push(actor.nombre);
        }
      });
    });

    Object.values(narrativaMap).forEach(({ texto, actores }) => {
      if (actores.length >= 2) {
        result.push({
          id: `cog_conv_${texto.slice(0, 20).replace(/\s/g, '_')}`,
          tipo: 'CONVERGENCIA',
          nivel: actores.length >= 3 ? 'Crítico' : 'Alto',
          titulo: `Convergencia narrativa detectada`,
          descripcion: `"${texto}" — compartida por ${actores.length} actores: ${actores.slice(0, 3).join(', ')}${actores.length > 3 ? ` y ${actores.length - 3} más` : ''}.`,
          actor: actores[0],
          actoresInvolucrados: actores,
          cognitiva: true
        });
      }
    });

    // ── Ordenar: Crítico primero, luego por IVT ────────────
    result.sort((a, b) => {
      const nivelOrder = { Crítico: 0, Alto: 1, Medio: 2, Bajo: 3 };
      const nA = nivelOrder[a.nivel] ?? 9;
      const nB = nivelOrder[b.nivel] ?? 9;
      if (nA !== nB) return nA - nB;
      return (b.ivt || 0) - (a.ivt || 0);
    });

    return result;
  }, [processedActors]);

  return alerts;
}